export const onScrollTop = () => {
  window.scrollTo({
    top: 0,
  });
};
